import React, { useState, useEffect } from 'react';
import {
  Award, Users, Wrench, Droplet, Zap, FileText,
  Clock, ShieldCheck, Leaf, ThumbsUp, Package,
  Shield, Star, CheckCircle,
} from 'lucide-react';
import { getBenefits } from '../api/api';

// Doit rester aligné avec iconOptions dans AdminBenefits.
const iconMap = {
  Award, Users, Wrench, Droplet, Zap, FileText,
  Clock, ShieldCheck, Leaf, ThumbsUp, Package,
  Shield, Star, CheckCircle,
};

export const Benefits = () => {
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBenefits = async () => {
      try {
        const data = await getBenefits();
        setBenefits(data);
      } catch (error) {
        console.error('Error fetching benefits:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBenefits();
  }, []);

  if (loading) {
    return (
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="animate-pulse">Chargement...</div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-gray-900 mb-4">
            Pourquoi choisir NETTO+ ?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            L'excellence du service de nettoyage professionnel à Liège
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon] || Award;
            return (
              <div
                key={benefit.id}
                className="group relative p-8 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:border-blue-200 hover:shadow-xl transition-all duration-500 hover:-translate-y-0.5"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                {/* Icon Container */}
                <div className="relative inline-flex mb-6">
                  <div className="absolute inset-0 bg-blue-600 rounded-2xl blur-xl opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
                  <div className="relative bg-blue-600 p-4 rounded-2xl group-hover:scale-110 transition-transform duration-500">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>

                {/* Decorative Corner */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-50 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
